module.exports = __webpack_public_path__ + "58c0f2e7b9163eb402e02df4bd8964f0.jpg";